import React from 'react'

import Header from '../../components/Header'
import Map from '../../components/Map'
import DownloadPointsBox from '../../components/DownloadPointsBox'
import MeasurementsPlot from '../../components/MeasurementsPlot'
import MapControl from '../../components/Map/MapControl'
import LayerControl from '../../components/Map/LayerControl'
import MapSpinner from '../../components/Map/MapSpinner'
import InfoBox from '../../components/Map/InfoBox'
import ChangelogBox from '../../components/Map/ChangelogBox'
import MapLegend from '../../components/Map/MapLegend'
import BaseMaps from '../../components/BaseMaps'
import VectorLayers from '../../components/VectorLayers'

import WMTSLayer from '../../components/Layers/WMTSLayer'

import { WMTS_URL, WMS_URL } from '../../config'

export default function MapView() {
  return (
    <>
      <Header></Header>
      <Map>
        <BaseMaps></BaseMaps>
        <VectorLayers></VectorLayers>
        <LayerControl></LayerControl>
        <WMTSLayer
          capabilitiesUrl={WMTS_URL}
          wmsUrl={WMS_URL}
          zIndex={3}
        ></WMTSLayer>
        <MapControl></MapControl>
        <InfoBox />
        <ChangelogBox></ChangelogBox>
        <DownloadPointsBox></DownloadPointsBox>
        <MeasurementsPlot></MeasurementsPlot>
        <MapSpinner></MapSpinner>
        <MapLegend></MapLegend>
      </Map>
    </>
  )
}
